// extracted by mini-css-extract-plugin
module.exports = {"ellipse":"VehicleHeroImage_ellipse__Q1mJI"};